import { Link } from '@tanstack/react-router';
import { Image } from '@unpic/react';
import { useEffect, useState } from 'react';
import { useShopifyStore } from '../../context/store-context';
import { getCartLines } from '../../utils/cart';
import { formatPrice } from '../../utils/format';
import Badge from '../badge/badge';
import Icon from '../icon';
import styles from './cart-indicator.module.scss';

export default function CartIndicator() {
  const {
    state: { cart, loading, lastItemAdded },
    resetLastItemAdded
  } = useShopifyStore();

  const [showMessage, setShowMessage] = useState(false);
  const total = getCartLines(cart).reduce(
    (acc, line) => acc + line.quantity,
    0
  );

  useEffect(() => {
    if (lastItemAdded) {
      setShowMessage(true);

      const timeout = setTimeout(() => {
        setShowMessage(false);
        resetLastItemAdded();
      }, 3000);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [lastItemAdded]);

  return (
    <div className={styles.cartIndicator}>
      <Link
        to="/cart"
        className={styles.cartIndicatorLink}
        activeProps={{ className: 'active' }}
        aria-label="Kosár"
      >
        <Icon className={styles.icon} name="shopping-bag" size={24} />
        <span className={styles.cartIndicatorText}>Kosár</span>
        <Badge
          className={`${styles.cartIndicatorCount} ${
            loading ? 'invisible' : ''
          }`}
        >
          {total}
        </Badge>
      </Link>
      {showMessage && lastItemAdded && (
        <Link className={styles.lastItemAdded} to="/cart">
          <div className={styles.lastItemAddedSuccess}>
            <Icon
              className={styles.notificationIcon}
              name="check"
              strokeWidth={2}
            />
            Termék a kosárba helyezve
          </div>
          {lastItemAdded.imageUrl && (
            <Image
              src={lastItemAdded.imageUrl}
              layout="fullWidth"
              aspectRatio={1}
              className={styles.productImage}
              background="var(--bs-tertiary-bg)"
              alt={`${lastItemAdded.productTitle} karkötő`}
            />
          )}
          <div className={styles.productInfo}>
            <div className={styles.productTitle}>
              {lastItemAdded.productTitle}
            </div>
            <div className={styles.productVariantTitle}>
              Méret: {lastItemAdded.variantTitle}
            </div>
            <div className={styles.productPrice}>
              {formatPrice(lastItemAdded.price)}
            </div>
          </div>
        </Link>
      )}
    </div>
  );
}
